// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"326":"6f1f7f84","353":"570af606"}[chunkId] + ".chunk.css";
};